import { Poll } from '../types';

export default class PollsState {
  polls: Poll[] = [];
}
